import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { useForm } from 'components/form/controller'
import Modal from 'modals/dialog'
import { cls } from 'utilities/dom'
import { size } from 'utilities/object'
import Layout from 'components/form/actions'
import { Plain, ButtonSubmit } from 'components/button'

const Actions = ({ progress, submissible, dismiss, submit }) => {
    const { formatMessage } = useIntl()

    const {
        touched,
        errors,
        trigger
    } = useForm()

    const disabled = (typeof submissible === 'boolean') ?
        !submissible :
        !touched.length

    if(progress.processed === progress.total) {
        return (
            <Modal.Footer>
                <Layout className="stretch">
                    <Plain
                        onClick={dismiss}
                        className="neutral">
                        <FormattedMessage
                            id="action_close"
                            defaultMessage="Close" />
                    </Plain>
                </Layout>
            </Modal.Footer>
        )
    }

    return (
        <Modal.Footer>
            <Layout>
                <Plain
                    onClick={dismiss}
                    className="neutral"
                    disabled={progress.busy}>
                    <FormattedMessage
                        id="action_cancel"
                        defaultMessage="Cancel" />
                </Plain>
                <ButtonSubmit
                    className={cls([
                        submit?.destructive ?
                            'destructive' :
                            'constructive',
                        progress.busy && 'loading'
                    ])}
                    disabled={disabled || !!size(errors) || progress.busy}
                    ref={trigger}>
                    {submit?.label ?? formatMessage({
                        id: 'action_save',
                        defaultMessage: 'Save'
                    })}
                </ButtonSubmit>
            </Layout>
        </Modal.Footer>
    )
}

export default Actions